import { NgModule } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { UserModule } from '../user/user.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { LottosWalletDetailsComponent } from './components/lottos-wallet-details/lottos-wallet-details.component';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { LayoutModule } from '../layouts/layout.module';
import { WorksheetListComponent } from './components/worksheet-list/worksheet-list.component';
import { WorksheetItemComponent } from './components/worksheet-item/worksheet-item.component';
import { SubscriptionsListComponent } from './components/subscriptions-list/subscriptions-list.component';
import { SubscriptionsListItemComponent } from './components/subscriptions-list-item/subscriptions-list-item.component';
import { SubscriptionsListItemRenewalsComponent } from './components/subscriptions-list-item-renewals/subscriptions-list-item-renewals.component';
import { SubscriptionsListItemSubscribedComponent } from './components/subscriptions-list-item-subscribed/subscriptions-list-item-subscribed.component';
import { CartItemSubscriptionsComponent } from './components/cart-item-subscriptions/cart-item-subscriptions.component';
import { CartSubscriptionsModalComponent } from './components/cart-item-subscriptions/cart-subscriptions-modal/cart-subscriptions-modal.component';
import { ShortLongDescriptionModule } from '@fgb/portal-component-library/src/lib/shared/short-long-description';
import { ErrorsModule } from '@fgb/portal-component-library/src/lib/shared/errors';
import { AuctionDetailsModule } from '@fgb/portal-component-library/src/lib/loyalty/auctions/auction-details';
import { AuctionPanelModule } from '@fgb/portal-component-library/src/lib/loyalty/auctions/auction-panel';
import { AuctionListModule } from '@fgb/portal-component-library/src/lib/loyalty/auctions/auction-list';
import { LoyaltyIconModule } from '@fgb/portal-component-library/src/lib/shared/loyalty-icon';
import { CountdownModule } from '@fgb/portal-component-library/src/lib/shared/countdown';
import { LottoDetailsModule } from '@fgb/portal-component-library/src/lib/loyalty/lottos/lotto-details';
import { LottosListItemModule } from '@fgb/portal-component-library/src/lib/loyalty/lottos/lottos-list-item';
import { LottosListModule } from '@fgb/portal-component-library/src/lib/loyalty/lottos/lottos-list';
import { BadgeListItemModule } from '@fgb/portal-component-library/src/lib/loyalty/badges';
import { MarketplaceDetailsModule } from '@fgb/portal-component-library/src/lib/loyalty/marketplace/marketplace-details';
import { MarketplaceListItemModule } from '@fgb/portal-component-library/src/lib/loyalty/marketplace/marketplace-list-item';
import { MarketplaceListModule } from '@fgb/portal-component-library/src/lib/loyalty/marketplace/marketplace-list';
import { SortBarModule } from '@fgb/portal-component-library/src/lib/shared/sort-bar';
import { MixedLoyaltyItemModule } from '@fgb/portal-component-library/src/lib/loyalty/mixed-loyalty';
import { ScorecardModule } from '@fgb/portal-component-library/src/lib/loyalty/scorecards';
import { ClubModule } from '../club/club.module';

@NgModule({
  declarations: [
    LottosWalletDetailsComponent,
    WorksheetListComponent,
    WorksheetItemComponent,
    SubscriptionsListComponent,
    SubscriptionsListItemComponent,
    SubscriptionsListItemRenewalsComponent,
    SubscriptionsListItemSubscribedComponent,
    CartItemSubscriptionsComponent,
    CartSubscriptionsModalComponent,
  ],
  exports: [
    LottosWalletDetailsComponent,
    WorksheetListComponent,
    WorksheetItemComponent,
    SubscriptionsListComponent,
    SubscriptionsListItemComponent,
    SubscriptionsListItemRenewalsComponent,
    SubscriptionsListItemSubscribedComponent,
    CartItemSubscriptionsComponent,
    CartSubscriptionsModalComponent,
  ],
  imports: [
    ClubModule,
    RouterModule,
    NgbModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    CarouselModule,
    BrowserAnimationsModule,
    SharedModule,
    InlineSVGModule.forRoot(),
    UserModule,
    LayoutModule,
    ErrorsModule,
    ShortLongDescriptionModule,
    AuctionDetailsModule,
    AuctionPanelModule,
    AuctionListModule,
    LottoDetailsModule,
    LottosListModule,
    LottosListItemModule,
    BadgeListItemModule,
    MarketplaceDetailsModule,
    MarketplaceListModule,
    MarketplaceListItemModule,
    MixedLoyaltyItemModule,
    LoyaltyIconModule,
    CountdownModule,
    SortBarModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: function HttpLoaderFactory(http: HttpClient) {
          return new TranslateHttpLoader(http, './assets/i18n/', '.json');
        },
        deps: [HttpClient],
      },
    }),
    ScorecardModule,
  ],
})
export class LoyaltyModule {}
